import { Eye, User } from 'lucide-react-native';
import { StyleSheet } from 'react-native';
import { Box, Tabs } from '../../../components/primitives';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';
import type { BoardVisibilityInfo } from '../../../types/leads';

interface BoardViewToggleProps {
  visibility: BoardVisibilityInfo;
  onViewModeChange: (viewMode: 'my' | 'team') => void;
}

export function BoardViewToggle({ visibility, onViewModeChange }: Readonly<BoardViewToggleProps>) {
  const { t } = useTranslation();

  if (visibility.mode === 'shared') {
    return null;
  }

  if (visibility.mode === 'individual' && !visibility.canViewTeam) {
    return null;
  }

  const tabs = [
    {
      key: 'my',
      label: t('leads.viewMode.myBoard'),
      icon: (
        <User
          size={14}
          color={visibility.viewMode === 'my' ? colors.primary[500] : colors.text.tertiary}
        />
      ),
    },
    ...(visibility.canViewTeam
      ? [
          {
            key: 'team',
            label: t('leads.viewMode.teamBoard'),
            icon: (
              <Eye
                size={14}
                color={visibility.viewMode === 'team' ? colors.primary[500] : colors.text.tertiary}
              />
            ),
          },
        ]
      : []),
  ];

  return (
    <Box style={styles.container}>
      <Tabs
        tabs={tabs}
        activeTab={visibility.viewMode}
        onChange={(key) => onViewModeChange(key as 'my' | 'team')}
        variant="segment"
        testID="board-view-toggle"
      />
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: tokens.spacing.xs,
  },
});
